import { useBreakpoint, DEFAULT_BREAKPOINT } from '@hub/design-system-base'
import React from 'react'
import { SearchButtonLarge } from './large'
import { SearchButtonSmall } from './small'
import { SearchButtonProps } from './types'

export const SearchButton: React.FC<SearchButtonProps> = props => {
  const breakpoint = useBreakpoint(DEFAULT_BREAKPOINT)

  const isSmallLayout = ['base', 'sm', 'md'].includes(breakpoint || 'base')

  return isSmallLayout ? (
    <SearchButtonSmall {...props} />
  ) : (
    <SearchButtonLarge {...props} />
  )
}
